var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.08535285,2 C9.03007711,2.15638946 9,2.32468229 9,2.5 C9,3.32842712 9.67157288,4 10.5,4 C11.3284271,4 12,3.32842712 12,2.5 C12,2.32468229 11.9699229,2.15638946 11.9146471,2 L16.9998938,2 C18.104522,2 19,2.8926228 19,3.99508929 L19,18.0049107 C19,19.1067681 18.1099416,20 16.9998938,20 L4.00010618,20 C2.89547804,20 2,19.1073772 2,18.0049107 L2,3.99508929 C2,2.8932319 2.89005841,2 4.00010618,2 L9.08535285,2 Z M5,5 L5,17 L16,17 L16,5 L5,5 Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 4,
  width: 9,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5,5 C9.11928813,5 8,3.88071187 8,2.5 C8,1.11928813 9.11928813,0 10.5,0 C11.8807119,0 13,1.11928813 13,2.5 C13,3.88071187 11.8807119,5 10.5,5 Z M10.5,3 C10.7761424,3 11,2.77614237 11,2.5 C11,2.22385763 10.7761424,2 10.5,2 C10.2238576,2 10,2.22385763 10,2.5 C10,2.77614237 10.2238576,3 10.5,3 Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 9,
  width: 7,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 11,
  width: 7,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 13,
  width: 7,
  height: 1
})))));
export default SvgForm;